export default __webpack_public_path__ + "static/media/add.5fe4a17a.png";